import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionManagementService } from '../session-management.service';

@Injectable({
    providedIn: 'root'
})
export class SessionGuard implements CanActivate {
    constructor(
        private sessionManagementService: SessionManagementService,
        private router: Router
    ) { }

    canActivate(): boolean {
        if (this.sessionManagementService.checkLoginExpiration()) {
            this.sessionManagementService.handleSessionExpiration();
            return false;
        }
        return true;
    }
}